<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 20 18"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 4.1743C8 -0.520142 1 -0.0201416 1 5.97989C1 11.9799 10 16.9801 10 16.9801C10 16.9801 19 11.9799 19 5.97989C19 -0.0201416 12 -0.520142 10 4.1743Z"
      :fill="filled ? color : emptyColor"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>

<script>
export default {
  name: 'Heart',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    filled: {
      type: Boolean,
      required: false,
      default: false
    },
    color: {
      type: String,
      required: false,
      default: '#000'
    },
    emptyColor: {
      type: String,
      required: false,
      default: '#FFF'
    }
  },
};

</script>
